import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box, ShadowBox } from '@components/Restyle';
import { PopupStatusItem } from '@components/Web/PopupStatusItem.web';

const POPUP_WIDTH = 220;

export type SubscriptionStatusPopupProps = {
  onPressActiveSubscriptions?: (newTitle: string) => void;
  onPressCanceledSubscriptions?: (newTitle: string) => void;
};

export const SubscriptionStatusPopup: React.FC<
  SubscriptionStatusPopupProps
> = ({ onPressActiveSubscriptions, onPressCanceledSubscriptions }) => {
  const { t } = useTranslation('models');

  return (
    <ShadowBox
      flex={1}
      width={POPUP_WIDTH}
      alignItems='center'
      justifyContent='center'
      borderRadius='xs'
      variant='base'
      backgroundColor='white'>
      <Box marginVertical='s'>
        <PopupStatusItem
          title={t('profile.subscriptionPlans.activeSubscriptions')}
          icon='RefreshCcw'
          width={POPUP_WIDTH}
          onPress={() => {
            onPressActiveSubscriptions?.(
              t('profile.subscriptionPlans.activeSubscriptions')
            );
          }}
        />
        <PopupStatusItem
          title={t('profile.subscriptionPlans.canceledSubscriptions')}
          icon='Archive'
          width={POPUP_WIDTH}
          onPress={() => {
            onPressCanceledSubscriptions?.(
              t('profile.subscriptionPlans.canceledSubscriptions')
            );
          }}
        />
      </Box>
    </ShadowBox>
  );
};
